import {
  useWSModalCustom,
  WSActions,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { ClientWorkFlowStatus } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryCache } from "@ws-react-query";
import React, { useState } from "react";
import { addNotification } from "../../../components/Notification/Notification";
import { QUERY_PAYABLE, QUERY_PAYABLES } from "../../../query/payments/keys";
import { paymentsService } from "../../../services/payments";
import { bulkActionFactory } from "../../../modules/BulkActions";
import { PayablesTableItemData } from "./PayablesTable";

type Props = {
  data: PayablesTableItemData[];
  onSuccess?: () => void;
} & WSModalCustomProps<any>;

export const ModalBulkPreApprove: React.FC<Props> = props => {
  const [isLoading, setIsLoading] = useState(false);

  const bulkPreApprove = bulkActionFactory({
    onStart: () => {
      setIsLoading(true);
    },
    action: async (item: PayablesTableItemData) => {
      const payableId = item.payable?.payableId || "";

      return await paymentsService.payable.update(payableId, {
        client: {
          workflowStatus: ClientWorkFlowStatus.PreApproved
        }
      });
    },
    onFinish: ({ successItems, failedItems }) => {
      WSQueryCache.invalidateQueries(QUERY_PAYABLES);
      WSQueryCache.invalidateQueries("QUERY_PAYABLES_TO_PRE_APPROVE");
      successItems.forEach(item => {
        WSQueryCache.invalidateQueries([
          QUERY_PAYABLE,
          item.payable?.payableId
        ]);
      });

      addNotification({
        timeout: 6000,
        text:
          `${successItems.length} payable${
            successItems.length > 1 ? "s" : ""
          } have been pre-approved` +
          (failedItems.length > 0 ? `, ${failedItems.length} failed` : "")
      });

      setIsLoading(false);

      props.onSuccess?.();
      props.onClose?.(undefined);
    }
  });

  const payablePluralized = "payable" + (props.data.length > 1 ? "s" : "");

  return (
    <WSModal
      blockClose={isLoading}
      size="S"
      title={`Pre-approve ${props.data.length} ${payablePluralized}?`}
      onClose={props.onClose}
    >
      <WSText.Heading5 mb="M"></WSText.Heading5>
      <WSText mb="XL">Pre-approve {payablePluralized} to be approved</WSText>

      <WSActions
        buttons={[
          {
            onClick: () => {
              bulkPreApprove.run(props.data);
            },
            label: "Pre-approve",
            loading: isLoading
          },
          {
            onClick: () => {
              props.onClose?.(undefined);
            },
            label: "Cancel",
            kind: "Tertiary"
          }
        ]}
      />
    </WSModal>
  );
};

export const useModalBulkPreApprove = () =>
  useWSModalCustom(ModalBulkPreApprove);
